<template>
  <v-container>
    <div 
      v-if="status === 'loading'" 
      style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; z-index: 995; background-color: transparent;"
    >
      <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
    </div>

    <v-row class="mx-auto my-16">
      <v-col>
        <v-card class="white--text mx-auto my-auto" persistent width="400" height="380" flat>
          <v-card-title primary-title>
            <div>
              <div class="text-h5 primary2--text text--darken-3 mt-5">Iniciar sesión</div>
              <span class="subtitle-1 secundary--text">¿No tienes una cuenta?</span>
              <router-link :to="{ name: 'signUp' }" style="text-decoration: none; color: inherit">
                <span class="subtitle-1 primary--text ml-2">Regístrate</span>
              </router-link>
            </div>
          </v-card-title>
          <v-card-text>
            <v-form width="70%" ref="myForm" @submit.prevent="save">
              <v-form-base
                id="form-base-complete"
                v-if="schemaForm && modelForm"
                :schema="schemaForm"
                :model="modelForm"
                @input="log"
                @click="log"
              />
              <div class="d-flex justify-end primary--text subtitle-1 mt-2 mr-3">
                <router-link
                  :to="{ name: 'pro-repass' }"
                  style="text-decoration: none; color: inherit"
                >
                  <span>¿Olvidaste tu contraseña?</span>
                </router-link>
              </div>
              <v-btn class="secundary2 white--text mr-4 text-capitalize" @click="save" type="submit">
                Iniciar sesión
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import VFormBase from 'vuetify-form-base';

export default {
  name: 'ProLogin',
  components: {
    VFormBase,
  },

  props: ['schemaForm', 'modelForm', 'save', 'status'],

  methods: {
    log(val) {
      let { on, key, obj, params } = val;
      if (
        on === 'click' &&
        key === 'subgroups.content' &&
        (params && params.tag) === 'prepend-inner'
      ) {
        window.print();
      }
      if (on === 'click' && key === 'password' && (params && params.tag) === 'append') {
        obj.schema.type === 'password'
          ? (obj.schema.appendIcon = 'mdi-eye-off')
          : (obj.schema.appendIcon = 'mdi-eye');
        obj.schema.type = obj.schema.type === 'password' ? 'text' : 'password';
      }
    },
  },
};
</script>

<style>
#form-base-complete .key-subgroups-content {
  background-color: #faf3e9;
  padding: 1rem;
}

#form-base-complete .key-subgroups-tasks {
  background-color: #e2eaf5;
  padding: 1rem;
}

@media print {
  html * {
    position: fixed;
    top: 0;
    bottom: 0;
    visibility: hidden;
  }

  .key-subgroups-content textarea {
    visibility: visible;
    left: 0;
    top: 0;
    bottom: 0;
  }

  .key-subgroups-content textarea * {
    visibility: visible;
  }
}
</style>
